import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "../../services/fetchApi";

export const useGetTypesEvtsMarquants = () => {
  const promise = () => fetchApi("/api/type_evts_marquants", { method: "get" });
  return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["type_evts_marquants"], promise, {});
};
